import * as React from 'react';
import { UIEventListeners } from '../../../../../common/src/ts/types/uievent';
import {
  registerUIEventListeners,
  unregisterUIEventListeners,
} from '../../../../../common/src/ts/utils/uievent';

export interface UIEventHandlerProps {
  uiEventListeners: UIEventListeners;
}

class UIEventHandler extends React.PureComponent<UIEventHandlerProps> {
  private element: HTMLDivElement | null = null;

  public componentDidMount() {
    if (this.element !== null) {
      registerUIEventListeners(this.element, this.props.uiEventListeners);
    }
  }

  public componentWillUnmount() {
    if (this.element !== null) {
      unregisterUIEventListeners(this.element, this.props.uiEventListeners);
    }
  }

  public componentDidUpdate(prevProps: UIEventHandlerProps) {
    if (this.element !== null) {
      if (prevProps.uiEventListeners !== this.props.uiEventListeners) {
        unregisterUIEventListeners(this.element, prevProps.uiEventListeners);
        registerUIEventListeners(this.element, this.props.uiEventListeners);
      }
    }
  }

  private handleRef = (el: HTMLDivElement) => this.element = el;

  public render() {
    const style: React.CSSProperties = {
      position: 'absolute',
      left: '0',
      top: '0',
      right: '0',
      bottom: '0',
      cursor: 'move',
    };

    return (
      <div ref={this.handleRef} style={style}>
        {this.props.children}
      </div>
    );
  }
}

export default UIEventHandler;
